var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0205(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "maa3nu7wka",
    d: "M5 4h38v16H5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "psvkslpnab",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 38,
    height: 16,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#maa3nu7wka"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    mask: "url(#psvkslpnab)",
    xlinkHref: "#maa3nu7wka",
    stroke: "#415CE9",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "5,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0205);
export default __webpack_public_path__ + "static/media/icon-legend-02-05.f5f9e95db9043d8dcca288ed1d61851e.svg";
export { ForwardRef as ReactComponent };